import Chip from "@mui/material/Chip";
import { useTranslation } from "i18n-fe";

// Card #1608 — AC1's "distinguishing a locked .sdf from a genuine failure":
// foxbox's PushStatusReport.cs sets `cause` to "locked" (a transient hold on
// the .sdf, operator action is to unlock/retry) or "unknown" (a genuine
// write failure with no positively-identified cause — reporting anything
// more specific would fabricate a diagnosis the data doesn't support, see
// that file's own header comment). `cause: null` covers this card's
// degrade-gracefully case (an older row, or any writer that isn't foxbox's
// JSON shape) — shown as a plain outlined chip rather than guessing.
//
// Semantic MUI Chip colors only, mirroring SheetSentChip/SheetStateChip —
// never `color="primary"`, which is the brand darkGrey and near-invisible in
// dark mode (see ThemeBrand.js's #813/#816 comments).
const CAUSE_DISPLAY = {
  locked: { color: "warning", variant: "filled", labelKey: "reviewQueue.fvdFailures.cause.locked" },
  unknown: { color: "error", variant: "filled", labelKey: "reviewQueue.fvdFailures.cause.unknown" },
};

export default function FvdPushFailureCauseChip({ cause, size = "small", ...props }) {
  const { t } = useTranslation("scoreadmin");
  const display = CAUSE_DISPLAY[cause] ?? {
    color: "default",
    variant: "outlined",
    labelKey: "reviewQueue.fvdFailures.cause.unclassified",
  };
  return (
    <Chip
      size={size}
      color={display.color}
      variant={display.variant}
      label={t(display.labelKey)}
      data-testid="fvd-push-failure-cause-chip"
      data-fvd-push-failure-cause={cause ?? "unclassified"}
      {...props}
    />
  );
}
